import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

interface Props extends SvgIconProps {
  innerOpacity?: number;
  outerOpacity?: number;
  fill?: string;
}

export function InfoIcon({
  innerOpacity = 0.2,
  outerOpacity = 0.75,
  fill = 'black',
  ...props
}: Props) {
  return (
    <SvgIcon {...props} fill="white">
      <path
        d="M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm1 13h-2v-6h2v6zm0-8h-2V7h2v2z"
        opacity={innerOpacity}
        fill={fill}
      />
      <path
        d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
        opacity={outerOpacity}
        fill="white"
      />
    </SvgIcon>
  );
}
